module.exports = __webpack_public_path__ + "img/Voltar.37ee1282.png";